import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'antd'
import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons'
import 'antd/dist/antd.css'
import 'Pages/Admin/Admin.scss'

function ImageViewModal({ visible, imageSrc, onClose }) {
  const [zoomLevel, setZoomLevel] = useState(1)

  useEffect(() => {
    if (visible) {
      setZoomLevel(1)
    }
  }, [visible])

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && visible) {
        onClose()
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [visible, onClose])

  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 0.25, 3))
  }

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 0.25, 0.5))
  }

  const handleWheel = (e) => {
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault()
      if (e.deltaY < 0) {
        handleZoomIn()
      } else {
        handleZoomOut()
      }
    }
  }

  if (!imageSrc) {
    return null
  }

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width="90%"
      style={{ top: 20 }}
      className="image-view-modal"
    >
      <div className="image-view-container" onWheel={handleWheel}>
        <div className="image-view-controls">
          <Button
            icon={<ZoomOutOutlined />}
            onClick={handleZoomOut}
            disabled={zoomLevel <= 0.5}
          >
            Zoom Out
          </Button>
          <span className="zoom-level">{Math.round(zoomLevel * 100)}%</span>
          <Button
            icon={<ZoomInOutlined />}
            onClick={handleZoomIn}
            disabled={zoomLevel >= 3}
          >
            Zoom In
          </Button>
        </div>
        <div className="image-view-content">
          <img
            src={imageSrc}
            alt="Full size view"
            className="image-view-img"
            style={{
              transform: `scale(${zoomLevel})`,
              transformOrigin: 'center center',
              transition: 'transform 0.2s ease',
            }}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ImageViewModal
